import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { TransporterCreateField } from './Field';

import cn from 'classnames';
import styles from './CreateFieldsColumns.module.css';
import { TRANSPORTER_FIELD_TYPES } from '../../constants';
import { setNewTransporterValue } from '../../actions';
import { selectNewTransporter } from '../../selectors';

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class CreateFieldsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    return this.props.onClose();
  }

  render() {
    return (
      <div className={styles.GridContainer}>
        <div className={styles.GridItem}>
          {TRANSPORTER_FIELD_TYPES.map(type => {
            return <TransporterCreateField key={type} type={type} />;
          })}
        </div>
      </div>
    );
  }
}

CreateFieldsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  reset: PropTypes.func,
  onNextModal: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: selectNewTransporter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    setValue(name, value) {
      dispatch(setNewTransporterValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CreateFieldsColumns = compose(withConnect, withRouter, injectIntl)(CreateFieldsColumnsComp);
